/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';

// TODO(dc): domainfiy
import TeacherFeedbackForm from 'edrolo/components/exams/grid/TeacherFeedbackForm';
import ExamTextResponse from './ExamTextResponse';
// TODO(dc): domainify
import ComplexSolution from 'edrolo/components/exams/solutions/ComplexSolution';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';

class PopoverContent extends Component {
  componentDidMount() {
    analytics.track('viewed student exam question response', {
      origin: 'exam_grid',
      question_id: this.props.question.id,
      response_id: this.props.response.id,
      sitting_id: this.props.sittingId,
      ...this.props.analyticsPayload,
    });
  }

  render() {
    const student = this.props.student;
    const question = this.props.question;
    const response = this.props.response;

    let markInfo;
    if (
      question.question_type === EXAM_QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE
    ) {
      markInfo = <p>{'This question was marked automatically'}</p>;
    } else if (
      [
        EXAM_QUESTION_TYPES.TEXT,
        EXAM_QUESTION_TYPES.WORKED,
        EXAM_QUESTION_TYPES.COMPLEX,
      ].includes(question.question_type)
    ) {
      let studentMark = response.text_marks_from_student;
      if ($.isNumeric(studentMark)) {
        // TODO: Remove jQuery
        studentMark = Math.round10(studentMark, 0);
        markInfo = (
          <h5 className="self">
            {`${
              student.name
            } self-marked this answer as ${studentMark}/${Math.round10(
              question.marks,
              0
            )}.`}
          </h5>
        );
      } else {
        markInfo = <h5>{`${student.name} hasn't self-marked this answer.`}</h5>;
      }
    }
    let teacherMark = response.text_marks_from_teacher || null;
    if (teacherMark !== null) {
      teacherMark = Math.round10(teacherMark, 0);
    }

    const feedbackData = {
      comment_from_teacher: response.comment_from_teacher,
      text_marks_from_teacher: this.props.responseMarks, // ;-)
      student: student.user,
      question: question.id,
      sitting: this.props.sittingId,
      questionType: question.question_type,
      maxMarks: this.props.questionMarks,
    };

    let yourAnswer = '';

    if (question.question_type === EXAM_QUESTION_TYPES.COMPLEX) {
      yourAnswer = <ComplexSolution question={question} response={response} />;
    } else {
      yourAnswer = (
        <ExamTextResponse
          className="answer"
          student={student}
          footer={markInfo}
        >
          {response.your_answer || 'None submitted'}
        </ExamTextResponse>
      );
    }

    return (
      <div className="mark-popover">
        <h5>{`${student.name}'s answer:`}</h5>
        {yourAnswer}
        {markInfo}
        <TeacherFeedbackForm
          data={feedbackData}
          origin="exam_grid"
          onChange={this.props.onChangedResponse}
          onCancel={this.props.onCancel}
        />
      </div>
    );
  }
}

export default PopoverContent;
